import { EventTypes } from 'integrations/enums/EventTypes';

export class SupportMethodsManager {
    private list = new Set<EventTypes>();

    public add(item: EventTypes): void {
        this.list.add(item);
    }

    public get isOnScrollAvailable() {
        return this.list.has(EventTypes.ON_SCROLL);
    }
}
